(() => {
  const label = document.querySelector('script[data-rcl-buy-now-label]')?.dataset.rclBuyNowLabel || 'Buy it now';
  function setup() {
    document.querySelectorAll('.f8pr-buy-button > .overlay-dynamic_buy_button').forEach(wrapper => {
      const form = wrapper.closest('form');
      if (!form || wrapper.querySelector('.rcl-buy-now')) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'rcl-buy-now';
      button.textContent = label;
      const sync = () => {
        const add = form.querySelector('button[type="submit"]');
        const disabled = button.getAttribute('aria-busy') === 'true' || !add || add.disabled || add.classList.contains('disabled') || !new FormData(form).get('id');
        if (button.disabled !== disabled) button.disabled = disabled;
      };
      button.addEventListener('click', () => {
        sync();
        if (button.disabled || !form.reportValidity()) return;
        let redirect = form.querySelector('input[name="return_to"]');
        if (!redirect) {
          redirect = document.createElement('input');
          redirect.type = 'hidden';
          redirect.name = 'return_to';
          form.appendChild(redirect);
        }
        redirect.value = (window.Shopify?.routes?.root || '/') + 'checkout';
        button.setAttribute('aria-busy', 'true');
        button.disabled = true;
        HTMLFormElement.prototype.submit.call(form);
      });
      wrapper.appendChild(button);
      wrapper.classList.add('rcl-buy-now-ready');
      sync();
      document.addEventListener('change', sync);
      new MutationObserver(sync).observe(form, {subtree:true, attributes:true, attributeFilter:['disabled','value','class']});
    });
  }
  setup();
  new MutationObserver(setup).observe(document.body, {childList:true, subtree:true});
})();